import React from 'react';
// import imgUrl1 from '../../img/404.2.png'

const NotFound = () => {
    return (
        <div>
            <div className="flex justify-center ">
                <img style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',

                }} className=" flex w-100 h-96 " src='https://previews.123rf.com/images/kaymosk/kaymosk1804/kaymosk180400006/100130939-error-404-page-not-found-error-with-glitch-effect-on-screen-vector-illustration-for-your-design-.jpg' alt="Not found" />
            </div>
        </div >
    );
};

export default NotFound;